/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';


class FocusOnShowDirective {
    public restrict = 'A';

    constructor(private $timeout: any) {

    }

    public link = ($scope: any, $element: any, $attr: any) => {
        this.$timeout(function (): void {
            $element[0].focus();
        }, 0);

    };

    public static DirectiveFn($timeout: any): FocusOnShowDirective {
        return new FocusOnShowDirective($timeout);
    }
}

FocusOnShowDirective.DirectiveFn.$inject = ['$timeout'];

angular.module('beneple.global').directive('focusOnShow', FocusOnShowDirective.DirectiveFn);




// WEBPACK FOOTER //
// ./frontend/scripts/global/directives/focus_on_show.directive.ts